export default "__VITE_ASSET__cUK4qVQx__"